// extracted by mini-css-extract-plugin
export default {"bioContainer":"bio_bioContainer__DQ6CC","bioImage":"bio_bioImage__5zmGx","bioText":"bio_bioText__f1JcD"};